export const championshipGames = [
  {
    id: 'ACC-championship',
    type: 'championship',
    conference: 'ACC',
    week: 13,
    homeTeam: 'Miami',
    awayTeam: 'Duke',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },{
    id: 'CUSA-championship',
    type: 'championship',
    conference: 'Conference USA',
    week: 13,
    homeTeam: 'Kennesaw State',
    awayTeam: 'Jacksonville State',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'SEC-championship',
    type: 'championship',
    conference: 'SEC',
    week: 13,
    homeTeam: 'Georgia',
    awayTeam: 'Alabama',
    homePoints: 1,
    awayPoints: 0,
    completed: false
  },
  {
    id: 'Big Ten-championship',
    type: 'championship',
    conference: 'Big Ten',
    week: 13,
    homeTeam: 'Ohio State',
    awayTeam: 'Indiana',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'Big 12-championship',
    type: 'championship',
    conference: 'Big 12',
    week: 13,
    homeTeam: 'Texas Tech',
    awayTeam: 'BYU',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'American-championship',
    type: 'championship',
    conference: 'American Athletic',
    week: 13,
    homeTeam: 'South Florida',
    awayTeam: 'Memphis',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'MW-championship',
    type: 'championship',
    conference: 'Mountain West',
    week: 13,
    homeTeam: 'Boise State',
    awayTeam: 'UNLV',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'SB-championship',
    type: 'championship',
    conference: 'Sun Belt',
    week: 13,
    homeTeam: 'James Madison',
    awayTeam: 'Southern Miss',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'MAC-championship',
    type: 'championship',
    conference: 'Mid-American',
    week: 13,
    homeTeam: 'Toledo',
    awayTeam: 'Ohio',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  },
  {
    id: 'Pac 12-championship',
    type: 'championship',
    conference: 'Pac-12',
    week: 13,
    homeTeam: 'Washington State',
    awayTeam: 'Oregon State',
    homePoints: 1,
    awayPoints: 0,
    completed: false,
  }
];